export default __webpack_public_path__ + "static/media/school2.05cb2246.webp";